import { render, staticRenderFns } from "./Communicationresourcesinfo.vue?vue&type=template&id=57d728e2"
import script from "./Communicationresourcesinfo.vue?vue&type=script&lang=js"
export * from "./Communicationresourcesinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports